import { CosmicJSClient } from "../../apis/cosmicjs-client";
import { HelpContent } from "../../domain/help/help-entity";

const CONTENTS_OBJECT_TYPE = "help-articles" as const;

const BUCKET = `graffer-console-contents` as const;

class ContentListService extends CosmicJSClient {
  constructor() {
    super(BUCKET);
  }

  async fetchContentList(
    query?: string,
    productId?: string,
    tagIds?: string[],
    limit?: number,
  ): Promise<HelpContent[]> {
    const result = await this.fetch<HelpContent>(
      JSON.stringify({
        type: CONTENTS_OBJECT_TYPE,
        ...(productId ? { "metadata.product": productId } : {}),
        ...(tagIds && tagIds.length > 0
          ? { "metadata.tag": { $in: tagIds } }
          : {}),
        ...(query
          ? {
              $or: [
                { title: { $regex: query, $options: "i" } },
                { "metadata.content": { $regex: query, $options: "i" } },
              ],
            }
          : {}),
      }),
      "id,slug,title,metadata.content,metadata.product,metadata.tag",
      "-order",
      limit,
    );
    return result.objects;
  }
}

export const contentListService = new ContentListService();
